import React from 'react';
import 'antd/lib/button/style/css';
import 'antd/lib/form/style/css';
import 'antd/lib/icon/style/css';
import '../../resources/css/customAnt.css';
import {Field} from 'redux-form';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button } from 'antd';
import languages from '../../language/languages';
import {connect} from 'react-redux';
import {required, requireden} from '../../helpers/validations'
import {userNormalizer} from "../../helpers/normalizers";
import {CreatePasswordField, CreateTextField} from "../../helpers/InputCreator";
import {
    CERTIFICATE_REQUEST_PKCS10_ROUTE,
    CERTIFICATE_REQUEST_ROUTE,
    GENERATE_P12_ROUTE,
    RECOVER_PASSWORD_ROUTE
} from "../Main/routes";
import PublicLayout from "../Layouts/Public";
import TitleAndInfo from "../TitleAndInfo";
import {reduxForm} from "redux-form";
import {push} from 'connected-react-router';
import login from '../../actions/login';

class Login extends React.Component
{
    handleLogin = (form) =>
    {
        this.props.login(form.userName,form.password);
    };

    render()
    {
        return (
            <PublicLayout isRA={this.props.isRA} title={'logo'}>
                <TitleAndInfo info={languages[this.props.language].loginMsg}/>
            <Form onSubmit={this.props.handleSubmit(this.handleLogin)}>
                <Field name="userName"
                       prefix={<MailOutlined className={'icon-font'} />}
                       component={CreateTextField}
                       size={'large'}
                       style={{marginBottom: '5px'}}
                       placeholder={languages[this.props.language].userName}
                       validate={this.props.language==='es'?[required]:[requireden]}
                       normalize={userNormalizer}
                       autocomplete={'new-password'}
                       hasFeedback/>
                <Field name="password"
                       prefix={<LockOutlined className={'icon-font'} />}
                       component={CreatePasswordField}
                       size={'large'}
                       className={'mb-10'}
                       visibilityToggle={'false'}
                       autocomplete={'new-password'}
                       placeholder={languages[this.props.language].password}
                       validate={this.props.language==='es'?[required]:[requireden]}
                       hasFeedback/>
                <Form.Item className={'text-center mb-10'}>
                    <Button type="primary" htmlType="submit" className={'light-blue rounded'}>
                        {languages[this.props.language].loginBtn}
                    </Button>
                </Form.Item>
                <Form.Item className={'text-center'}>{this.props.isRA?<Button onClick={()=>this.props.push(CERTIFICATE_REQUEST_ROUTE)} type="primary" className={'light-blue rounded'}>
                        {languages[this.props.language].publicreqLabel}
                    </Button>:
                    <Button onClick={()=>this.props.push(GENERATE_P12_ROUTE)} type="primary" className={'light-blue rounded'}>
                        {languages[this.props.language].generateP12}
                    </Button>}
                </Form.Item>
                <Form.Item className={'text-center'}>
                {this.props.isRA?<Button onClick={()=>this.props.push(CERTIFICATE_REQUEST_PKCS10_ROUTE)} type="primary" className={'light-blue rounded'}>
                    {languages[this.props.language].publicpkcs10Label}
                </Button>:
                    <a className={'link'} href={window.netcopkiurlid + '/servlet/caCert'}>{languages[this.props.language].caCertificate}</a>
                }
                </Form.Item>
                <Form.Item className={'text-center'} >
                    <p className={'link'} onClick={() => {
                        this.props.push(RECOVER_PASSWORD_ROUTE)
                    }}>{languages[this.props.language].forgot}</p>
                </Form.Item>

            </Form>
            </PublicLayout>
        );
    }
}

const mapStateToProps = state => {
    return {
        language: state.auth.language,
        isRA:state.auth.isRA
    };
};

export default connect(mapStateToProps, {login,push})((reduxForm({form: 'login_form'})(Login)));
